// PrivacyPolicy (§11) — public, indexable route (no auth wall) required by
// Google Play and linked in the Data Safety form. Redesigned to the token shell.
import React from "react";
import { useNavigate } from "react-router-dom";
import Screen from "./ui/Screen";

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div>
    <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, fontWeight: 700, color: "var(--text)", marginBottom: 6 }}>{title}</div>
    <div>{children}</div>
  </div>
);

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Screen title="Privacy Policy" showBack hideNav onBack={() => navigate(-1)}>
      <div className="mc-in" style={{ padding: "18px 16px 26px", display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ fontSize: 13, color: "var(--text-3)" }}>Last updated: July 2026</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 16, fontSize: 14, color: "var(--text-2)", lineHeight: 1.6 }}>
          <Section title="Data we collect">
            MystiCrafter stores your game progress, profile details (display name, email), and gameplay statistics
            so we can sync your account across devices and power leaderboards.
          </Section>
          <Section title="How we use it">
            Your data powers leaderboards, multiplayer matchmaking, and cross-device sync. We never sell personal
            data to third parties.
          </Section>
          <Section title="Advertising">
            The free web and Android versions show ads via Google AdSense and Google AdMob. These partners may use
            device identifiers and cookies to serve relevant ads, as described in Google's advertising policies.
          </Section>
          <Section title="Your rights">
            You can request a copy of your data or delete your account at any time from Settings → Delete account, or
            directly at <span style={{ color: "var(--accent-text)" }}>/delete-account</span>. Deletion is permanent and
            removes all associated records.
          </Section>
          <Section title="Children">
            MystiCrafter is not directed at children under 13. We do not knowingly collect personal information from
            children under 13.
          </Section>
          <Section title="Contact">
            Questions about privacy? Reach us at <span style={{ color: "var(--accent-text)" }}>privacy@mysticrafter.com</span>.
          </Section>
        </div>
      </div>
    </Screen>
  );
};

export default PrivacyPolicy;
